import { Injectable } from '@angular/core';
import { Usuario, Usuario2, Usuario3, UserOptions } from '../../models/usuario.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { map } from 'rxjs/operators';
import { Perfisica, PerMoral, ContribuyenteFisica, ContribuyenteMoral, DocumentoPropiedad } from '../../models/personas.model';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';


@Injectable()
export class ContribuyentesService {

  usuario: Usuario;
  token: string;
  usuario2: Usuario2;
  idUsuario: string;

  constructor(
    public http: HttpClient,
    public router: Router
  ) {

  }


  crearPersonaFisica( params ) {

    const url = `${environment.URL_SERVICIOS}/people/`;


    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return this.crearArregloPersonaFisica(resp);
              }));
  }

  crearArregloPersonaFisica( usuariosObj: any) {

    const usuarios: any[] = [];
    const resul: any[] = [];

    if ( usuariosObj === null ) { return []; }
    Object.keys ( usuariosObj ).forEach( key => {
      const usuario: any = usuariosObj[key];
      usuarios.push( usuario );
    });
    // tslint:disable-next-line: forin
    resul.push( usuarios[0].attributes );

    return resul;

}

  crearContribuyenteFisica( contribuyentefisica: ContribuyenteFisica, idf: any ) {

    const url = `${environment.URL_SERVICIOS}/contributors?contributor[contributor_type]=${contribuyentefisica.tipo}&contributor[bank]=${contribuyentefisica.banco}&contributor[account_number]=${contribuyentefisica.ncuentafisica}&contributor[clabe]=${contribuyentefisica.clabefisica}&contributor[extra1]=${contribuyentefisica.cbfisica}&contributor[person_id]=${idf}`;

    return this.http.post( url, null ).pipe(
              map( (resp: any) => {
                return resp.data.attributes.id;
              }));
  }

  crearPersonaMoral( params ) {

    const url = `${environment.URL_SERVICIOS}/legal_entities/`;


    return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return this.crearArregloPersonaMoral(resp);
              }));
  }

  crearArregloPersonaMoral( usuariosObj: any) {

    const usuarios: any[] = [];
    const resul: any[] = [];

    if ( usuariosObj === null ) { return []; }
    Object.keys ( usuariosObj ).forEach( key => {
      const usuario: any = usuariosObj[key];
      usuarios.push( usuario );
    });
    // tslint:disable-next-line: forin
  //  console.log( usuarios[0][prop].attributes );
    resul.push( usuarios[0].attributes );

    return resul;

}

crearContribuyenteMoral( contribuyentemoral: ContribuyenteMoral, idm: any ) { 

  const url = `${environment.URL_SERVICIOS}/contributors?contributor[contributor_type]=${contribuyentemoral.tipo}&contributor[bank]=${contribuyentemoral.banco}&contributor[account_number]=${contribuyentemoral.ncuentamoral}&contributor[clabe]=${contribuyentemoral.clabemoral}&contributor[extra1]=${contribuyentemoral.cbmoral}&contributor[legal_entity_id]=${idm}`;

  return this.http.post( url, null ).pipe(
            map( (resp: any) => {
              return resp.data.attributes.id;
            }));
}

getContribuyentes() {

  const url = `${environment.URL_SERVICIOS}/contributors`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );

}

getFactoringContributors() {

  const url = `${environment.URL_SERVICIOS}/get_factoring_contributors`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

crearArregloContribuyente( contribuObj: any) {

  const contribuyentes: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
 /* Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    contribuyentes.push( rol );
  }); */
  // tslint:disable-next-line: forin
  for (const prop in contribuObj.data) {
  resul.push( contribuObj.data[prop].attributes );
  }

  return resul;

}

getPersonaFisica( idf: string ) {

  const url = `${environment.URL_SERVICIOS}/people/${idf}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArreglopf(resp);
    } )
  );

}

crearArreglopf( contribuObj: any) {

  const contribuyentes: any[] = [];
  const resul: any[] = [];

  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    contribuyentes.push( rol );
  });
  // tslint:disable-next-line: forin

//  console.log( usuarios[0][prop].attributes );
  resul.push( contribuyentes[0].attributes );


 // console.log(resul);

  return resul;

}

crearDP( id, params ) {

const url = `${environment.URL_SERVICIOS}/contributors/${id}/property_documents`;

return this.http.post( url, params ).pipe(
              map( (resp: any) => {
                return resp.data.attributes.id;
              }));
}

// LISTAS

getFiscalRegime() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/PERSON_FISCAL_REGIME`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getCompanySegmentsCurrency() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/COMPANY_SEGMENTS_CURRENCY`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getAdresstype() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/CONTRIBUTOR_ADDRESS_ADDRESS_TYPE`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getAsentamientotype() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/CONTRIBUTOR_ADDRESS_SUBURB_TYPE`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getPersonGender() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/PERSON_GENDER`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getPersonFiscalRegime() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/PEOPLE_FISCAL_REGIME`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getPersonBank() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/BANK_NUMBER`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getLegalEntityFiscalRegime() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/LEGAL_ENTITIES_FISCAL_REGIME`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getCompanySector() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/COMPANY_SECTOR`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getCompanyDigitalSign() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/COMPANY_DIGITAL_SIGN`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getCompanySubSector() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/COMPANY_SUBSECTOR`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getSupplierSector() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/SUPPLIER_SECTOR`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getSupplierSubSector() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/SUPPLIER_SUBSECTOR`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getSupplierDigitalSign() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/SUPPLIER_DIGITAL_SIGN`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getSupplierdebt_type() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/SUPPLIER_SEGMENT_DEBT_TYPE`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getMaritalStatusFisica() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/PEOPLE_MARTIAL_STATUS`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getTipoIdentificacionFisica() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/PEOPLE_ID_TYPE`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

getParentezco() {

  const url = `${environment.URL_SERVICIOS}/lists/domain/SIGNATORIES_PARTNERSHIP`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloList(resp);
    } )
  );

}

crearArregloList( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];

  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes.value );

  }

  return resul;

}

getFirmantes() {

  const url = `${environment.URL_SERVICIOS}/reports/signatories`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

getContribuyentesMain() {

  const url = `${environment.URL_SERVICIOS}/reports/contributors_main`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return resp;
    } )
  );

}

// CYP

getCadenaxcontribuyente(id) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/companies`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloCadena(resp);
    } )
  );

}

getCompanyPorId(id_contributor, id_company) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id_contributor}/companies/${id_company}`;

  return this.http.get(url)

}

crearArregloCadena( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes );

  }

  return resul;

}

actualizaCadenaxContributente( idcont, idcompany, params ) {

  const url = `${environment.URL_SERVICIOS}/contributors/${idcont}/companies/${idcompany}`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));

}


creaCadenaxContribuyente( id, params ) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/companies`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

contributorDetails( params ) {

  const url = `${environment.URL_SERVICIOS}/contributor_details`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

patchContributorDetails( params, idcd ) {

  const url = `${environment.URL_SERVICIOS}/contributor_details/${idcd}`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

getContributorDetails( idc ) {

  const url = `${environment.URL_SERVICIOS}/get_contributor_details_by_id?id=${idc}`; //SOSPECHOSO

  return this.http.get( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

creaProveedorxContribuyente( id, params ) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/suppliers`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

getProveedorxContribuyente(id) {

  const url = `${environment.URL_SERVICIOS}/contributors/${id}/suppliers`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloProveedor(resp);
    } )
  );

}

crearArregloProveedor( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes );

  }

  return resul;

}

actualizaProveedorxContributente( idcont, idcompany, params ) {

  const url = `${environment.URL_SERVICIOS}/contributors/${idcont}/suppliers/${idcompany}`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));

}

getCompanySegments( idc ) {

  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );

}

getCompanySegment( idc, ids ) {

  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments/${ids}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloSegment(resp);
    } )
  );

}

crearArregloSegment( contribuObj: any) {
  const contribuyentes: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
  resul.push( contribuObj.data.attributes );
  return resul;

}

guardaSegmento( idc, params ) {
  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments`;
  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

borraSegmento( idc, ids ) {
  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments/${ids}`;
  return this.http.delete( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

actualizaSegmento( idc, ids, params ) {

  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_segments/${ids}`;
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

creaUsdSegment( id, params ) {

  const url = `${environment.URL_SERVICIOS}/suppliers/${id}/usd_supplier_segments`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

creaSegment( id, params ) {

  const url = `${environment.URL_SERVICIOS}/suppliers/${id}/supplier_segments`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

getUsdSegment( ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/usd_supplier_segments`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );
}

getSegment( ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/supplier_segments`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );
}

patchUsdSegment( ids, idsegment, params ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/usd_supplier_segments/${idsegment}/`;
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

patchSegment( ids, idsegment, params ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/supplier_segments/${idsegment}/`;
  return this.http.patch( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

borraSegmentoSeg( idc, ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${idc}/supplier_segments/${ids}`;
  return this.http.delete( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

borraSegmentoUsd( idc, ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${idc}/usd_supplier_segments/${ids}`;
  return this.http.delete( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

// DIRECCIONES

getStates() {

  const url = `${environment.URL_SERVICIOS}/countries/1/states`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloStates(resp);
    } )
  );

}

getMunicipios( idm ) {

  const url = `${environment.URL_SERVICIOS}/states/${idm}/municipalities`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloStates(resp);
    } )
  );

}

getColoniasxcp( cp ) {

  const url = `${environment.URL_SERVICIOS}/postal_codes/pc/${cp}`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloStates(resp);
    } )
  );

}

crearArregloStates( contribuObj: any) {

  const rr: any[] = [];
  const resul: any[] = [];
  if ( contribuObj === null ) { return []; }
  Object.keys ( contribuObj ).forEach( key => {
    const rol: any = contribuObj[key];
    rr.push( rol );
  });
  // tslint:disable-next-line: forin
  for ( const prop in rr[0] ) {

    resul.push( rr[0][prop].attributes );

  }

  return resul;

}

creaFirmantexContribuyente( idc , params ) {

  const url = `${environment.URL_SERVICIOS}/contributors/${idc}/signatories`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

creaDireccionxContribuyente( idc , params ) {

  const url = `${environment.URL_SERVICIOS}/contributors/${idc}/contributor_addresses`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

getCompanySuplierProjects( ids ) {

  const url = `${environment.URL_SERVICIOS}/suppliers/${ids}/supplier_projects`;

  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );

}

// SUPLIER PROYECTOS //////////////////////////////////////////////////////////
getCompanyProject(idcompany, idcompanyproject) {
  const url = `${environment.URL_SERVICIOS}/companies/${idcompany}/company_projects/${idcompanyproject}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );
}

getCadenas() {

  const url = `${environment.URL_SERVICIOS}/reports/payment_companies`;

  return this.http.get( url ).pipe(
    map ( (resp: any) => {
      return resp;
    }
    )
  );

}

getCompanyProjects(idcompany) {
  const url = `${environment.URL_SERVICIOS}/companies/${idcompany}/company_projects`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );
}

guardaProyecto(params) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${params.suplier_id}/supplier_projects`;
  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

actualizaProyecto(params) {

  const url = `${environment.URL_SERVICIOS}/suppliers/${params.suplier_id}/supplier_projects/${params.id}`;

  return this.http.patch( url, params ).pipe(
    map( (resp: any) => { return resp;
    } ));
}

borraProyecto( idc, ids ) {
  const url = `${environment.URL_SERVICIOS}/suppliers/${idc}/supplier_projects/${ids}`;
  return this.http.delete( url ).pipe(
    map( (resp: any) => {
      return resp;
    }));
}

getProjectName( idp ) {
  const url = `${environment.URL_SERVICIOS}/company_projects/${idp}`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return (resp);
    } )
  );
}

getcompany(idc) {
const url = `${environment.URL_SERVICIOS}/companies/${idc}`;
return this.http.get(url).pipe(
  map( (resp: any) => {
    return (resp);
  } )
);
}
///////////////////////////////////////////////////////////////////////////////


// CLIENTES //////////

creaClienteCadena( id, params ) {

  const url = `${environment.URL_SERVICIOS}/companies/${id}/company_customers`;

  return this.http.post( url, params ).pipe(
    map( (resp: any) => {
      return resp;
    }));

}

getclientescadena(idc) {
  const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_customers`;
  return this.http.get(url).pipe(
    map( (resp: any) => {
      return this.crearArregloContribuyente(resp);
    } )
  );
  }

  borraCliente( idc, idcliente ) {
    const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_customers/${idcliente}`;
    return this.http.delete( url ).pipe(
      map( (resp: any) => {
        return resp;
      }));
  }

  getCompanyCliente( idc, idcliente ) {

    const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_customers/${idcliente}`;
  
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return this.crearArregloSegment(resp);
      } )
    );
  
  }

  actualizaCliente( idc, ids, params ) {
    const url = `${environment.URL_SERVICIOS}/companies/${idc}/company_customers/${ids}`;
    return this.http.patch( url, params ).pipe(
      map( (resp: any) => {
        return resp;
      }));
  }
// PARA QUE UN FONDEADOR PUEDA TENER VARIAS LINEAS DE CREDITO POR CADENA /////////////////////
  getFundingCreditLineType() {

    const url = `${environment.URL_SERVICIOS}/get_general_param?key=FUNDING_CREDIT_LINE_TYPE`; //SOSPECHOSO



    return this.http.get(url).pipe(
      map( (resp: any) => {
        return (resp);
      } )
    );

  }

  getCadenasParaFondeador() {

    const url = `${environment.URL_SERVICIOS}/reports/payment_companies`;
  
    return this.http.get( url ).pipe(
      map ( (resp: any) => {
        return resp;
      }
      )
    );
  
  }
  getDebType() {

    const url = `${environment.URL_SERVICIOS}/lists/domain/CREDIT_LINE_DEBT_TYPE`;



    return this.http.get(url).pipe(
      map( (resp: any) => {
        return this.crearArregloList(resp);
      } )
    );

  }

  getCreditLines(idfunder) {
    const url = `${environment.URL_SERVICIOS}/funders/${idfunder}/credit_lines`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return this.crearArregloContribuyente(resp);
      } )
    );
  }

  getCompanyName(idc) {
    const url = `${environment.URL_SERVICIOS}/companies/${idc}`;
    return this.http.get(url).pipe(
      map( (resp: any) => {
        return (resp);
      } )
    );
  }
// PARA QUE UN FONDEADOR PUEDA TENER VARIAS LINEAS DE CREDITO POR CADENA /////////////////////
}
